/* eslint-disable camelcase */
/**
 * Search suggestions module for displaying product and article suggestions while typing in the search box
 */
export class SearchSuggestions {
  constructor(searchBox, inputField) {
    this.searchPageUrl = $('.js-site-search-url').data('search-page-url');
    this.searchApiUrl = $('.js-site-search-url').data('search-autocomplete-url');
    this.searchBox = searchBox;
    this.inputField = inputField;
    this.suggestionsBox = searchBox.find('.js-search-suggestions-box');
    this.productsListContainer = this.suggestionsBox.find('.js-search-suggestions-products-list');
    this.textsListContainer = this.suggestionsBox.find('.js-search-suggestions-texts-list');
    this.debounceTimeout = null;
    this.debounceDelay = 300; // milliseconds to wait before making an API call
    this.maxResults = 3;
    this.abortController = null;

    this.addEvents();
  }
  /**
   * Add event listeners for search input changes and document clicks
   */
  addEvents() {
    this.inputField.on('input', event => this.onInputChange(event));
    this.inputField.on('keydown', event => this.handleKeyboardNavigation(event));
    this.suggestionsBox.on('click', '.search-suggestions-all-results', () => {
      const currentInputValue = $('.js-search-header.site-search-box--is-expanded .js-input-site-search').val()
      || $('.js-input-search-main').val();

      window.location.href = `${this.searchPageUrl}?q=${encodeURIComponent(currentInputValue || '')}`;
    });
    this.suggestionsBox.on('click', '.search-suggestion-item', (e) => {
      const title = $(e.currentTarget).data('title');

      if (title) {
        window.location.href = `${this.searchPageUrl}?q=${encodeURIComponent(title)}`;
      }
    });
    $(document).on('click.searchSuggestions', event => this.handleClickOutside(event));
  }

  /**
   * Handle keyboard navigation within the suggestions box
   * @param {Object} event - Keyboard event
   */
  handleKeyboardNavigation(event) {
    if (this.suggestionsBox.hasClass('u-display-none')) { return }

    const { which } = event;
    const allItems = this.suggestionsBox.find('.search-suggestion-item');
    const currentFocusedItem = this.suggestionsBox.find('.search-suggestion-item--focused');
    const index = currentFocusedItem.length ? allItems.index(currentFocusedItem) : -1;

    if (which === 40) { // down
      event.preventDefault();
      this.focusNextItem(allItems, index);
    } else if (which === 38) { // up
      event.preventDefault();
      this.focusPreviousItem(allItems, index);
    } else if (which === 13 && currentFocusedItem.length) { // enter
      event.preventDefault();
      window.location.href = currentFocusedItem.attr('href');
    } else if (which === 27) { // escape
      this.hideSuggestions();
    }
  }

  /**
   * Focus the next item in the suggestions list
   * @param {jQuery} allItems - All suggestion items
   * @param {Number} currentIndex - Current focused item index
   */
  focusNextItem(allItems, currentIndex) {
    if (allItems.length === 0) {
      return;
    }

    const nextIndex = currentIndex < allItems.length - 1 ? currentIndex + 1 : 0;
    this.focusItemAtIndex(allItems, nextIndex);
  }

  /**
   * Focus the previous item in the suggestions list
   * @param {jQuery} allItems - All suggestion items
   * @param {Number} currentIndex - Current focused item index
   */
  focusPreviousItem(allItems, currentIndex) {
    if (allItems.length === 0) {
      return;
    }

    const prevIndex = currentIndex > 0 ? currentIndex - 1 : allItems.length - 1;
    this.focusItemAtIndex(allItems, prevIndex);
  }

  /**
   * Focus a specific item in the suggestions list
   * @param {jQuery} allItems - All suggestion items
   * @param {Number} index - Index to focus
   */
  focusItemAtIndex(allItems, index) {
    allItems.removeClass('search-suggestion-item--focused');
    $(allItems[index]).addClass('search-suggestion-item--focused');
  }

  /**
   * Handle input changes and trigger search suggestions with debounce
   * @param {Object} event - Input event
   */
  onInputChange(event) {
    const searchTerm = event.target.value.trim();

    if (searchTerm.length === 0) {
      this.hideSuggestions();

      return;
    }

    if (searchTerm.length >= 1) {
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }

      this.debounceTimeout = setTimeout(() => {
        this.fetchSuggestions(searchTerm);
      }, this.debounceDelay);
    }
  }

  fetchSuggestions(searchTerm) {
    // const dummyProducts = [
    //   { id: 1, title: 'Product Alpha', img: 'https://www.hygienesystem.com/images/blog/essity-logo.jpg', url: '/product/alpha' },
    //   { id: 2, title: 'Product Beta', img: 'https://www.hygienesystem.com/images/blog/essity-logo.jpg', url: '/product/beta' },
    //   { id: 3, title: 'Product Gamma', img: 'https://www.hygienesystem.com/images/blog/essity-logo.jpg', url: '/product/gamma' },
    //   { id: 4, title: 'Advanced Product', img: 'https://www.hygienesystem.com/images/blog/essity-logo.jpg', url: '/product/advanced' },
    //   { id: 5, title: 'Special Product', img: 'https://www.hygienesystem.com/images/blog/essity-logo.jpg', url: '/product/special' }
    // ];

    // const dummyTexts = [
    //   { id: 1, title: 'How to Use Our Products', url: '/articles/how-to-use' },
    //   { id: 2, title: 'Product Care Instructions', url: '/articles/product-care' },
    //   { id: 3, title: 'Benefits of Our Technology', url: '/articles/technology-benefits' },
    //   { id: 4, title: 'Product Comparison Guide', url: '/articles/comparison-guide' },
    //   { id: 5, title: 'Frequently Asked Questions', url: '/articles/faq' }
    // ];

    // const products = dummyProducts.slice(0, this.maxResults);
    // const texts = dummyTexts.slice(0, this.maxResults);

    // this.displaySuggestions(products, texts, searchTerm);

    if (this.abortController) {
      this.abortController.abort();
    }

    this.abortController = new AbortController();
    const { signal } = this.abortController;

    fetch(`${this.searchApiUrl}?q=${encodeURIComponent(searchTerm)}`, { signal })
    .then(res => res.json())
    .then(data => {
      const products = Array.isArray(data?.products) ? data.products : [];
      const texts = Array.isArray(data?.pages) ? data.pages : [];

      if (products.length === 0 && texts.length === 0) {
        this.hideSuggestions();

        return;
      }

      this.displaySuggestions(products, texts, searchTerm);
    })
    .catch((error) => {
      if (error.name !== 'AbortError') {
        this.hideSuggestions();
      }
    });
  }

  /**
   * Highlights matching parts of a given term within a text string.
   * This method wraps matched segments in a <strong> tag to visually emphasize them.
   *
   * @param {string} text - The input string (e.g., a product title).
   * @param {string} term - The search term to highlight within the text.
   * @returns {string} - The resulting string with matched terms wrapped in <strong> tags.
   */
  highlightMatch(text, term) {
    if (!term || term.length === 0) {
      return text;
    }

    const escapedTerm = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(escapedTerm, 'gi');

    return text.replace(regex, '<strong>$&</strong>');
  }

  /**
   * Display suggestions in the suggestions box
   * @param {Array} products - Array of product objects
   * @param {Array} texts - Array of text/article objects
   * @param {String} searchTerm - User's search term
   */
  displaySuggestions(products, texts, searchTerm) {
    this.clearSuggestions();

    if (products.length > 0) {
      this.suggestionsBox.find('.js-search-suggestions-products').removeClass('u-display-none');

      products.forEach(product => {
        const productItem = $(`
          <div class="search-suggestion-item search-suggestion-product" data-title="${product.title}">
            <div class="search-suggestion-image-box">
              <img class="search-suggestion-image" src="${product.img || ''}" alt="${product.title}" width="40" height="40">
            </div>
            <div class="search-suggestion-content">
              ${this.highlightMatch(product.title, searchTerm)}
            </div>
          </div>
        `);

        this.productsListContainer.append(productItem);
      });
    } else {
      this.suggestionsBox.find('.js-search-suggestions-products').addClass('u-display-none');
      this.suggestionsBox.find('.search-suggestions-texts').css({
        'border': 'none',
        'padding': '0'
      });
    }

    if (texts.length > 0) {
      this.suggestionsBox.find('.js-search-suggestions-texts').removeClass('u-display-none');

      texts.forEach(text => {
        const textItem = $(`
          <div class="search-suggestion-item" data-title="${text.title}">
            <div class="search-suggestion-content">
              ${this.highlightMatch(text.title, searchTerm)}
            </div>
          </div>
        `);

        this.textsListContainer.append(textItem);
      });
    } else {
      this.suggestionsBox.find('.js-search-suggestions-texts').addClass('u-display-none');
    }

    if (products.length > 0 || texts.length > 0) {
      this.showSuggestions();
    }
  }

  /**
   * Show the suggestions box
   */
  showSuggestions() {
    let containerWidth = this.inputField.outerWidth();

    if (containerWidth && containerWidth > 0) {
      this.suggestionsBox.css('width', containerWidth + 'px');
    }

    this.suggestionsBox.removeClass('u-display-none');
  }

  /**
   * Hide the suggestions box
   */
  hideSuggestions() {
    this.suggestionsBox.addClass('u-display-none');
    this.clearSuggestions();
  }

  /**
   * Clear all suggestion content
   */
  clearSuggestions() {
    this.productsListContainer.empty();
    this.textsListContainer.empty();
  }

  /**
   * Handle clicks outside the search container to close suggestions
   * @param {Object} event - Click event
   */
  handleClickOutside(event) {
    if (!$(event.target).closest('.js-search-header, .js-site-search-page').length &&
      !this.suggestionsBox.hasClass('u-display-none')) {
      this.hideSuggestions();
    }
  }
}